import ReportsList from '../../components/reports/reports/list.vue';
import ReportDetails from '../../components/reports/reports/report-details.vue';

import CaseReportDetails from '../../v2/components/reports/cases/report';
import Cases from '../../v2/components/reports/cases/cases';
import CaseLists from '../../v2/components/reports/case-lists/case-lists';
import CaseListDetails from '../../v2/components/reports/case-lists/case-list-details';
import CaseDetails from '../../v2/components/reports/cases/case-details';
import NewCase from '../../v2/components/reports/cases/new-case';

import FieldDetails from '../../v2/components/form-template/upsert-templates/common/field-details';
import CaseTemplates from '../../v2/components/form-template/templates-list/case-templates';

import NewCaseTemplate from '../../v2/components/form-template/upsert-templates/case/new-template';
import EditCaseTemplate from '../../v2/components/form-template/upsert-templates/case/edit-template';
import CopyCaseTemplate from '../../v2/components/form-template/upsert-templates/case/copy-template';

import NewProjectTemplate from '../../v2/components/form-template/upsert-templates/project/new-template';
import EditProjectTemplate from '../../v2/components/form-template/upsert-templates/project/edit-template';
import CopyProjectTemplate from '../../v2/components/form-template/upsert-templates/project/copy-template';

import RecycleBin from '../../v2/components/administration/recycle-bin';
import ApiManagement from '../../v2/components/administration/api-management';
import QRManagement from '../../v2/components/administration/qr-management';
import UpsertQR from '../../v2/components/administration/qr-management/upsert';

import { ROLES, ACCESS_TO_REPORTS, LICENSE_MODULES } from '../../../../../constants';

const modules = ACCESS_TO_REPORTS;

export default [
  {
    path: '/',
    name: 'home',
    redirect: '/dashboard',
    meta: {
      title: '',
      requiresAuth: true,
      modules: [LICENSE_MODULES.REPORTS, LICENSE_MODULES.IS_REPORTS_PART],
      roles: '*',
    },
  },
  {
    path: '/api-management',
    name: 'Api management',
    component: ApiManagement,
    meta: {
      title: 'Api Management',
      requiresAuth: true,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/qr-management',
    name: 'qr-management',
    component: QRManagement,
    meta: {
      title: 'QR Code Management',
      requiresAuth: true,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/crate-qr',
    name: 'create-qr',
    component: UpsertQR,
    meta: {
      title: 'Create QR Code',
      requiresAuth: true,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      isGoBackBtn: true,
    },
  },
  {
    path: '/qr/:id',
    name: 'qr-details',
    component: UpsertQR,
    meta: {
      title: 'QR Code Details',
      requiresAuth: true,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/recycle-bin',
    name: 'recycle-bin',
    component: RecycleBin,
    meta: {
      title: 'Recycle Bin',
      requiresAuth: true,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/reports/cases/new',
    name: 'new-case',
    component: NewCase,
    meta: {
      title: 'new_case',
      requiresAuth: true,
      roles: '*',
      modules: modules,
      isGoBackBtn: true,
    },
  },
  {
    path: '/reports/cases/:id',
    name: 'case-details',
    component: CaseDetails,
    meta: {
      title: 'Case Details',
      requiresAuth: true,
      roles: '*',
      modules: modules,
    },
  },
  {
    path: '/reports/cases/:id/report/:reportId',
    name: 'case-report-details',
    component: CaseReportDetails,
    meta: {
      title: 'Report Details',
      requiresAuth: true,
      roles: '*',
      modules: modules,
      isGoBackUrl: 'case-details',
    },
  },
  {
    path: '/reports/cases/:id/new-report',
    name: 'case-new-report',
    component: CaseReportDetails,
    meta: {
      title: 'Create New Report',
      requiresAuth: true,
      roles: '*',
      modules: modules,
    },
  },
  {
    path: '/reports/cases/:id/reports',
    name: 'case-reports',
    component: ReportsList,
    meta: {
      title: 'reports',
      requiresAuth: true,
      roles: '*',
      modules: modules,
    },
  },
  {
    path: '/reports/report/:id',
    name: 'report-details',
    component: ReportDetails,
    meta: {
      title: 'Report Details',
      requiresAuth: true,
      roles: '*',
      modules: modules,
    },
  },
  {
    path: '/reports/cases',
    name: 'cases',
    component: Cases,
    meta: {
      title: 'cases',
      requiresAuth: true,
      roles: '*',
      modules: modules,
    },
  },
  {
    path: '/reports/case-lists',
    name: 'case-lists',
    component: CaseLists,
    meta: {
      title: 'Case lists',
      requiresAuth: true,
      roles: '*',
      modules: modules,
    },
  },
  {
    path: '/reports/case-list/:id',
    name: 'case-list-details',
    component: CaseListDetails,
    meta: {
      title: 'Case list details',
      requiresAuth: true,
      roles: '*',
      modules: modules,
    },
  },
  {
    path: '/reports/templates',
    name: 'templates',
    component: CaseTemplates,
    meta: {
      title: 'templates',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/reports/new-template/:id',
    name: 'new-template',
    component: NewCaseTemplate,
    meta: {
      title: 'New Case Template',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/reports/new-template/:id/field-details',
    name: 'field-details',
    component: FieldDetails,
    meta: {
      title: 'Field details',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/reports/copy-template/:id',
    name: 'copy-template',
    component: CopyCaseTemplate,
    meta: {
      title: 'New Case Template',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/reports/templates/:id/edit',
    name: 'edit-template',
    component: EditCaseTemplate,
    meta: {
      title: 'Edit Case Template',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/one/new-content-template/:id',
    name: 'new-content-template',
    component: NewProjectTemplate,
    meta: {
      title: 'New Content Template',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/one/new-content-template/:id/field-details',
    name: 'content-field-details',
    component: FieldDetails,
    meta: {
      title: 'Field details',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/one/copy-content-template/:id',
    name: 'copy-content-template',
    component: CopyProjectTemplate,
    meta: {
      title: 'New Content Template',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
  {
    path: '/one/content-templates/:id/edit',
    name: 'edit-content-template',
    component: EditProjectTemplate,
    meta: {
      title: 'Edit Content Template',
      requiresAuth: true,
      modules: modules,
      roles: '*',
    },
  },
];
